import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import SceneSOAImg from "@/assets/report-assets/scene-soa-tooltip.png";

/*
 * SOAInfoModal component
 *
 * This modal displays information about the Share of Attention (SOA) metric.
 */
export const SOAInfoModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2>SOA (Share of Attention)</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>

      {/* Image */}
      <div className="flex items-center justify-center">
        <img src={SceneSOAImg} alt="SOA visualization" className="w-[261px] rounded-lg" />
      </div>

      {/* Description */}
      <p className="text-center">Share of Attention measures attention an element will likely recieve within the scene.</p>
    </div>
  );
};
